import React, { useState, useEffect, useRef } from 'react';

import { Row, Col, Badge, Progress } from 'reactstrap'
import Icon from '../iconxs'
const HeroSection = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(true);
    const [loadingPercent, setLoadingPercent] = useState(0);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const videoRef = useRef(null);
    const loadingRef = useRef(null);

    // Handle percentage-based loading
    useEffect(() => {
        if (!isLoading) return;

        const interval = setInterval(() => {
            setLoadingPercent(prev => {
                const increment = videoLoaded ? 15 : 5;
                const newPercent = Math.min(prev + increment, 100);

                // When we hit 100%
                if (newPercent === 100) {
                    clearInterval(interval);
                    setTimeout(() => {
                        console.log("Transitioning from loading screen");
                        setIsLoading(false);
                    }, 500);
                }

                return newPercent;
            });
        }, 100);

        return () => clearInterval(interval);
    }, [isLoading, videoLoaded]);

    // Trigger visibility after loading is done
    useEffect(() => {
        if (!isLoading) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isLoading]);

    // Handle video loading and set playback speed
    useEffect(() => {
        if (videoRef.current) {
            const handleVideoLoad = () => {
                console.log('Video loaded successfully');
                // Set playback speed to 0.5 (half speed)
                videoRef.current.playbackRate = 0.5;
                setVideoLoaded(true);
            };

            const handleVideoError = () => {
                console.log('Video loading failed, using fallback');
                setVideoLoaded(true);
            };

            videoRef.current.addEventListener('loadeddata', handleVideoLoad);
            videoRef.current.addEventListener('error', handleVideoError);

            // Try to play video with half speed
            const playVideo = () => {
                videoRef.current.playbackRate = 0.5; // Set to half speed
                videoRef.current.play().catch(e => {
                    console.log("Autoplay prevented, trying muted:", e);
                    videoRef.current.muted = true;
                    videoRef.current.play().catch(e2 => {
                        console.log("Muted autoplay also prevented:", e2);
                    });
                });
            };

            playVideo();

            // Set a timeout to proceed even if video takes too long
            const videoTimeout = setTimeout(() => {
                console.log('Video loading timeout, proceeding anyway');
                setVideoLoaded(true);
            }, 5000);

            return () => {
                if (videoRef.current) {
                    videoRef.current.removeEventListener('loadeddata', handleVideoLoad);
                    videoRef.current.removeEventListener('error', handleVideoError);
                }
                clearTimeout(videoTimeout);
            };
        }
    }, []);

    return (

        < section
            ref={loadingRef}
            className={`loading-screen ${!isLoading ? 'loading-hidden' : ''}`
            }
        >
            <div style={{ "opacity": loadingPercent / 100 }} className={loadingPercent + " loading-content"}>
                <div className="loading-logo">
                    <div className="d-flex logo-placeholder">
                        <div ><Icon /></div> <span className="px-2 ml-2 logo-text">RTX</span>
                    </div>

                    <Progress color="warning" value={loadingPercent} className=""></Progress>
                </div>
            </div>
            <div style={{ "opacity": loadingPercent / 100 }} className='badge-loading-container'>
                <div className="text-center">
                    <Col className="text-center justify-content-space-between  d-flex" xl={{ size: 9, offset: 2 }}>

                        <span className='badge' >CPC</span>
                        <span className='badge' >VIDEO</span>
                        <span className='badge' >GOOGLE Ads</span>
                        <span className='badge' >CPL</span>
                        <span className='badge' >CPM</span>
                        <span className='badge' >AI SEO</span>
                    </Col>
                </div>
            </div>

        </section >
    );
};

export default HeroSection;